import {ReplaySubject} from "rxjs";


export class UIBaseComponent {
  destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  ngOnDestroyed(){
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
